import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-user",
  "use": "icon-user-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol viewBox=\"0 0 22 22\" id=\"icon-user\"><path d=\"M7.421 13.343l-3.225.46a2.75 2.75 0 0 0-2.363 2.722v2.267c0 .76.616 1.375 1.375 1.375h15.584c.76 0 1.375-.616 1.375-1.375v-2.267a2.75 2.75 0 0 0-2.363-2.722l-3.225-.46A5.478 5.478 0 0 1 11 14.667a5.478 5.478 0 0 1-3.579-1.324zm1.194-1.391c.66.566 1.496.881 2.385.881.89 0 1.725-.315 2.385-.881l.63-.541 4.048.577A4.583 4.583 0 0 1 22 16.525v2.267A3.208 3.208 0 0 1 18.792 22H3.208A3.208 3.208 0 0 1 0 18.792v-2.267a4.583 4.583 0 0 1 3.937-4.537l4.048-.577.63.54zM11 1.833A3.667 3.667 0 0 0 7.333 5.5v3.667a3.667 3.667 0 0 0 7.334 0V5.5A3.667 3.667 0 0 0 11 1.833zM11 0a5.5 5.5 0 0 1 5.5 5.5v3.667a5.5 5.5 0 0 1-11 0V5.5A5.5 5.5 0 0 1 11 0z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./app/icons/icon-user.svg
// module id = 894
// module chunks = 74